import { render, staticRenderFns } from "./ProcessosSearch.vue?vue&type=template&id=29948b96&scoped=true&"
import script from "./ProcessosSearch.vue?vue&type=script&lang=js&"
export * from "./ProcessosSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProcessosSearch.vue?vue&type=style&index=0&id=29948b96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29948b96",
  null
  
)

export default component.exports